export default __webpack_public_path__ + "static/Content-1-5554fb68757e18d8573c469e7c0db019.webm";